/**
 * File customizer.js.
 *
 * Theme Customizer enhancements for a better user experience.
 *
 * Contains handlers to make Theme Customizer preview reload changes asynchronously.
 */
var ContentCubeLatestPortfolio = function(){
	var _initInstances = function () {
		var updateSinglePage = function(data, id) {
			var filtered = data.find(x=> x.id == id);
			var filteredindex = data.findIndex(x => x.id == id);
			var cbp_popup_wrap = $("<div></div>");
			cbp_popup_wrap.addClass("cbp-popup-wrap cbp-popup-singlePage cbp-popup-singlePage-open cbp-popup-transitionend cbp-popup-singlePage-sticky cbp-popup-ready");
			var cbp_popup_content = $("<div></div>");
			cbp_popup_content.addClass("cbp-popup-content");
			cbp_popup_content.html(filtered.content.rendered);
			cbp_popup_wrap.append(cbp_popup_content);
			cbp_popup_wrap.css({display: 'block'});
			var cbp_header = $("<div></div>");
			cbp_header.addClass("cbp-popup-navigation-wrap");
			var cbp_header_inner = $("<div><div>");
			cbp_header_inner.addClass("cbp-popup-navigation");

			var cbp_close = $("<div></div>");			
			cbp_close.addClass("cbp-popup-close");
			cbp_close.on('click', function(){
				cbp_popup_wrap.css({display: 'none'});
				cbp_popup_wrap.remove();
			})
			cbp_header_inner.append(cbp_close);

			var cbp_next = $("<div></div>");
			cbp_next.addClass("cbp-popup-next");
			cbp_next.on('click', function(){
				filteredindex = filteredindex+1;
				var next = data[filteredindex];
				if(next)
					cbp_popup_content.html(next.content.rendered);
			})
			cbp_header_inner.append(cbp_next);

			var cbp_prev = $("<div></div>");
			cbp_prev.addClass("cbp-popup-prev");
			cbp_prev.on("click", function(){
				filteredindex = filteredindex-1;
				var prev = data[filteredindex];
				if(prev)
					cbp_popup_content.html(prev.content.rendered);
			})
			cbp_header_inner.append(cbp_prev);
			
			cbp_header.append(cbp_header_inner);
			cbp_popup_wrap.append(cbp_header);
			$("body").append(cbp_popup_wrap);
		}
		var singlePageCallback = function(url, element, id){
			// to update singlePage content use the following method: this.updateSinglePage(yourContent)
			var t = this;

			$.ajax({
				url: url,
				type: 'GET',
				dataType: 'html',
				timeout: 5000
			})
			.done(function (result) {
				updateSinglePage(JSON.parse(result), id);
			})
			.fail(function () {
				updateSinglePage("Error! Please refresh the page!");
			});
		}

		$("#grid-container .cbp-singlePage").click(function(e){
			var id = $(this).data('postid');
			var url = "https://newlinedev.wpengine.com/wp-json/wp/v2/"+"portfolio/?per_page=50&order=asc";
			singlePageCallback(url, e, id);

			return false;
		});
	};
	return {
		init: function(){
			_initInstances();
		}
	}
}();
var pageanimations = function(){
	var _initInstances = function(){
		var $animation_elements = $('.custom_animate');
		var $window = $(window);

		var check_if_in_view = function() {
			var window_height = $window.height();
			var window_top_position = $window.scrollTop();
			var window_bottom_position = (window_top_position + window_height);
		  
			$.each($animation_elements, function() {
			  var $element = $(this);
			  var element_height = $element.outerHeight();
			  var element_top_position = $element.offset().top + 150;
			  var element_bottom_position = (element_top_position + element_height);
		  
			  //check to see if this current container is within viewport
			  if ((element_bottom_position >= window_top_position) &&
				  (element_top_position <= window_bottom_position)) {
				$element.addClass('do_animate');
			  } else {
				$element.removeClass('do_animate');
			  }
			});
		};

		
		
		$window.on('scroll', check_if_in_view);
		$window.on('scroll resize', check_if_in_view);
	};
	return {
		init: function(){
			_initInstances();
		}
	}
}();
$(document).ready(function () {
	ContentCubeLatestPortfolio.init();
	pageanimations.init();
});
( function( $ ) {
	// Smooth scroll for the navigation menu and links with .scrollto classes
	var scrolltoOffset = $('#header').outerHeight() - 21;
	if (window.matchMedia("(max-width: 991px)").matches) {
	  scrolltoOffset += 20;
	}
	// Toggle .header-scrolled class to #header when page is scrolled
	$(window).scroll(function() {
		if ($(this).scrollTop() > 100) {
			$('#header').addClass('header-scrolled');
			$('#topbar').addClass('topbar-scrolled');
		} else {
			$('#header').removeClass('header-scrolled');
			$('#topbar').removeClass('topbar-scrolled');
		}
	});

	if ($(window).scrollTop() > 100) {
		$('#header').addClass('header-scrolled');
		$('#topbar').addClass('topbar-scrolled');
	}
	
	$('.dropdown-menu .dropdown > a').on('click', function(e) {
		if (!$(this).next().hasClass('show')) {
		  $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
		}
		var $subMenu = $(this).next(".dropdown-menu");
		$subMenu.toggleClass('show');

		$(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
		  $('.dropdown-submenu .show').removeClass("show");
		});

		return false;
	});

	$('.customer-logos').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1500,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 4
            }
        }, {
            breakpoint: 520,
            settings: {
                slidesToShow: 3
            }
        }]
    });
	
} )( jQuery );
